<template>
  <div class="did-you-mean" v-if="show >= 0 || fixEmail">
    <template v-if="show >= 0">
      Did you mean <a class="link blue" @click="returnCorrect">{{ $options.suspects[show].correct }}</a>?
    </template>
    <template v-else-if="fixEmail">
      Did you mean <a class="link blue" @click="returnCorrect">{{ email.replace(/@/g, (val, index, str) => index === str.indexOf('@') ? val : '') }}</a>?
    </template>
  </div>
</template>

<script>
export default {
  props: {
    email: {
      type: String,
    },
  },
  watch: {
    email() {
      this.show = -1;
      this.fixEmail = false;
    },
  },
  methods: {
    checkEmail() {
      const { email } = this;
      const numAts = (email.match(/@/g) || []).length;

      if (numAts > 1) {
        this.fixEmail = true;
        return;
      }

      this.fixEmail = false;

      const middlePart = email.split('@')[1];
      if (middlePart) {
        const foundMiddlePart = this.$options.suspects.findIndex(suspect => suspect.incorrect.includes(middlePart));
        if (foundMiddlePart >= 0) {
          this.show = foundMiddlePart;
          return;
        }

        const lastPart = middlePart.split('.')[1];
        const foundLastPart = this.$options.suspects.findIndex(suspect => suspect.incorrect.includes(lastPart));
        if (foundLastPart >= 0) {
          this.show = foundLastPart;
          return;
        }
      }

      this.show = -1;
    },
    returnCorrect() {
      if (this.fixEmail) {
        // eslint-disable-next-line
        this.$emit('correctEmail', this.email.replace(/@/g, (val, index, str) => index === str.indexOf('@') ? val : ''));
        return;
      }

      const firstSplit = this.email.split('@');
      if (firstSplit[1]) {
        const foundMiddlePart = this.$options.suspects.findIndex(suspect => suspect.incorrect.includes(firstSplit[1]));
        if (foundMiddlePart >= 0) {
          this.$emit('correctEmail', `${firstSplit[0]}${this.$options.suspects[foundMiddlePart].correct}`);
          return;
        }

        const lastSplit = firstSplit[1].split('.');
        const foundLastPart = this.$options.suspects.findIndex(suspect => suspect.incorrect.includes(lastSplit[1]));
        if (foundLastPart >= 0) {
          this.$emit('correctEmail', `${firstSplit[0]}@${lastSplit[0]}${this.$options.suspects[foundLastPart].correct}`);
        }
      }
    },
  },
  data() {
    return {
      show: -1,
      fixEmail: false,
      timeout: null,
    };
  },
  suspects: [
    {
      correct: '@gmail.com',
      incorrect: ['glail.com', 'gmai.com', 'gnail.com', 'gmail.se'],
    },
    {
      correct: '@telia.com',
      incorrect: ['teli.com'],
    },
    {
      correct: '@hotmail.com',
      incorrect: ['hotnail.com', 'hotnail.se', 'hotmail.se', 'hotmail.co'],
    },
    {
      correct: '@msn.com',
      incorrect: ['mns.com'],
    },
    {
      correct: '.com',
      incorrect: ['gom', 'con', 'clm'],
    },
    {
      correct: '.se',
      incorrect: ['sr'],
    },
  ],
};
</script>

<style lang="scss" scoped>
.did-you-mean {
  color: gray;
  font-size: 13px;
  margin-top: 2px;
  margin-bottom: 10px;
  text-align: left;

  a {
    font-weight: 500;
  }
}
</style>
